import { authApi } from './authService';
import type {
  BackendMemberLink,
  CreateMemberPayload,
  UpdateMemberPayload,
} from '@/types/members';

const BASE = '/members';

export const memberService = {
  async list(): Promise<BackendMemberLink[]> {
    const response = await authApi.get(BASE);
    return response.data.data;
  },

  async create(payload: CreateMemberPayload): Promise<BackendMemberLink> {
    const response = await authApi.post(BASE, payload);
    return response.data.data;
  },

  async update(
    memberId: string,
    payload: UpdateMemberPayload,
  ): Promise<BackendMemberLink> {
    const response = await authApi.put(`${BASE}/${memberId}`, payload);
    return response.data.data;
  },

  async remove(memberId: string): Promise<{ removed: boolean }> {
    const response = await authApi.delete(`${BASE}/${memberId}`);
    return { removed: response.data.removed };
  },

  async block(memberId: string): Promise<BackendMemberLink> {
    const response = await authApi.patch(`${BASE}/${memberId}/block`);
    return response.data.data;
  },

  async unblock(memberId: string): Promise<BackendMemberLink> {
    const response = await authApi.patch(`${BASE}/${memberId}/unblock`);
    return response.data.data;
  },
};
